import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { IoCalendarOutline, IoOptions } from "react-icons/io5";
import { PushButton } from "../../atoms/buttons/PushButton";

interface Props {
  startDate: Date;
  endDate: Date;
  filterCount: number;
  onOpenGeneralFilterDrawer: () => void;
  onOpenTimeRangeFilterDrawer: () => void;
}

export const DisinfectionFilterButtons = ({
  startDate,
  endDate,
  filterCount,
  onOpenGeneralFilterDrawer,
  onOpenTimeRangeFilterDrawer,
}: Props) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"flex-end"}
      flexDirection={"row"}
      alignItems={"center"}
    >
      <PushButton
        onClick={onOpenTimeRangeFilterDrawer}
        variant="outlined"
        startIcon={<IoCalendarOutline />}
      >
        {format(startDate, "d MMM yyyy")} - {format(endDate, "d MMM yyyy")}
      </PushButton>
      <PushButton
        onClick={onOpenGeneralFilterDrawer}
        variant="outlined"
        startIcon={<IoOptions />}
        sx={(theme) => ({
          marginLeft: theme.spacing(6),
        })}
        endIcon={
          filterCount !== 0 ? (
            <Box
              sx={(theme) => ({
                backgroundColor: theme.palette.primary.main,
                borderRadius: 100,
                padding: "4px 6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              })}
            >
              <Typography
                variant="body2"
                color="white"
                sx={() => ({
                  fontSize: "11px",
                  lineHeight: "11px",
                  textAlign: "center",
                })}
              >
                {filterCount}
              </Typography>
            </Box>
          ) : null
        }
      >
        Filter
      </PushButton>
    </Box>
  );
};
